// smartEstimateAssistantApi.ts
import {
  SmartEstimateChatRequest,
  SmartEstimateChatResponse,
  GetConversationResponse
} from './smartEstimateAssistantType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class SmartEstimateAssistantApi {
  static async estimateChat(request: SmartEstimateChatRequest): Promise<SmartEstimateChatResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/smart_estimate_assistant/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
        credentials: 'include',
      });

      const responseBody = await response.json();

      if (response.ok) {
        return responseBody;
      } 
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      } 
      else if (response.status === 422 || response.status === 429) {
        const errorBody = await response.json();
        throw new Error(errorBody.error || `Error ${response.status}: ${response.statusText}`);
      } 
      else {
        throw new Error(`${responseBody.error} status ${response.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error('Failed to chat with assistant: An unknown error occurred.');
      }
    }
  }

  // ← ADD NEW METHOD
  static async getConversation(conversationId: string): Promise<GetConversationResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/smart_estimate_assistant/${conversationId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      const responseBody = await response.json();
      if (response.ok) {
        return responseBody;
      } 
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      } 
      else if (response.status === 404) {
        throw new Error('Conversation not found.');
      } 
      else {
        throw new Error(`${responseBody.error} status ${response.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error('Failed to fetch conversation: An unknown error occurred.');
      }
    }
  }
}

export default SmartEstimateAssistantApi;